import React from 'react'

import { useTranslation } from 'react-i18next'

import Divider from '@layout/Divider'
import { useSession } from '@stores/globalData/globalData.store'

import SideNavItem from './SideNavItem'

const PurchaseNav: React.FC = () => {
  const { t } = useTranslation()
  const session = useSession()

  return (
    <>
      <Divider />
      <p className="font-medium text-base ml-2 mb-2">{t('siteSidebar.purchase')}</p>
      {session.community.default_community && (
        <>
          <SideNavItem
            href="/plans"
            external
            label={t('siteSidebar.allPlans')}
            iconName="nf-upgrade"
          />
          <SideNavItem
            href="/premium"
            external
            label={t('siteSidebar.premium')}
            iconName="nf-upgrade"
          />
          <SideNavItem
            href="/learn"
            external
            label={t('siteSidebar.learn')}
            iconName="nf-upgrade"
          />
          <SideNavItem
            href="/highered"
            external
            label={t('siteSidebar.higherEd')}
            iconName="nf-education"
          />
          <SideNavItem
            href="/gift_card"
            external
            label={t('siteSidebar.giftCard')}
            iconName="nf-card"
          />
        </>
      )}
      <SideNavItem
        href="/activate"
        external
        label={t('siteSidebar.activateCode')}
        iconName="nf-activation"
        iconWidth="w-4"
      />
    </>
  )
}

export default PurchaseNav
